import React from 'react';
import { RoundButton } from '@UI-Elements/Buttons/RoundedSelectButtonWithImage';
interface Props {
  groupTableBy: { value: string; icon: string; disabled: boolean }[];
  selectedTable: string;
  setSelectedTable: (table: string) => void;
}
export const FilterButtons: React.FC<Props> = ({ groupTableBy, selectedTable, setSelectedTable }) => (
  <div className="flex gap-4 p-3">
    {groupTableBy.map(({ value, icon, disabled }, index) => (
      <RoundButton
        key={index}
        isSelected={selectedTable === value}
        image={`/assets/icons/blue-flat/${icon}.svg`}
        setAsSelected={() => setSelectedTable(value)}
        value={value}
        disabled={disabled}
      ></RoundButton>
    ))}
  </div>
);
